// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1w6wVTyWHrcdrN {\n  float: left;\n}\n._2pljYHHtEslQQ5 {\n  margin-left: -2px;\n  float: right;\n  position: relative;\n}\n._2scJw1knhaeSJT {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 50%;\n  background: rgba(0, 0, 0, 0.2);\n  font-size: 12px;\n  color: #172B4D;\n  float: right;\n  margin-left: -2px;\n}\n._3jkFG-JsCf1aV5 {\n  cursor: pointer;\n  transition: background 0.3s ease;\n}\n._3jkFG-JsCf1aV5:hover {\n  background: rgba(0, 0, 0, 0.4);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"facepile": "_1w6wVTyWHrcdrN",
	"avatar": "_2pljYHHtEslQQ5",
	"showMore": "_2scJw1knhaeSJT",
	"showMoreClickable": "_3jkFG-JsCf1aV5"
};
export default ___CSS_LOADER_EXPORT___;
